/**
 * Хозяйство сессии — то, что выбрано в переключателе «Хозяйство ▾» (AK-866 В-3),
 * или единственное доступное, если выбирать не из чего. Чистое правило — то же,
 * что у `usePlanningFarmScope` (без deep-link'а и подписки на смену области).
 *
 * Нужно действиям «по хозяйству» вне экранов планирования: предпросмотр импорта
 * полей шлёт `farm_id` (ADR-081 rev.6 D5 — путь хозяйства), приглашение в
 * «Команде» подставляет хозяйство (AK-886).
 */
import type { AvailableScopes } from './ScopeTree';

export function sessionFarmIdOf(data: AvailableScopes | undefined): string | null {
  if (!data || !Array.isArray(data.available)) return null;
  if (data.current?.scope_type === 'farm' && data.current.scope_id) return data.current.scope_id;
  const farms = data.available.filter((s) => s.scope_type === 'farm');
  return farms.length === 1 ? (farms[0].scope_id ?? null) : null;
}
